import { render } from "./corporate-policy-component.vue?vue&type=template&id=09c82582"
import script from "./corporate-policy-component.vue?vue&type=script&lang=js"
export * from "./corporate-policy-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__